export const ORDERS_SORT_BY = [
  {
    value: 'dateDesc',
    name: 'Newest - Oldest',
  },
  {
    value: 'dateAsc',
    name: 'Oldest - Newest',
  },
  {
    value: 'costDesc',
    name: '$$$ - $',
  },
  {
    value: 'costAsc',
    name: '$ - $$$',
  },
];

export const ORDERS_FILTER_BY_DATE = [
  {
    value: '1',
    name: 'Past Day',
  },
  {
    value: '7',
    name: 'Past Week',
  },
  {
    value: '30',
    name: 'Last 30 Days',
  },
  {
    value: '180',
    name: 'Last 6 Months',
  },
];

export const ORDER_PLACED_BY = {
  ME: 'Me',
  OTHER_ASSOCIATE: 'Other Associate',
  CLIENT: 'Client',
};
export const ORDER_STATUS = {
  SHIPPED: 'Shipped',
  PENDING: 'Pending',
  ISSUE: 'Issues',
  RETURNED: 'Returned',
  TAKE: 'Take',
  CANCELLED: 'Cancelled',
};

export const ORDER_BRAND = {
  BG: 'BG',
  NM: 'NM',
};

export const ORDER_CHANNEL = {
  inStore: 'In-store',
  online: 'Online',
  cmos: 'CMOS',
  connect: 'Connect',
};

export const ORDERS_FILTERS_PLACED_BY = [
  { value: ORDER_PLACED_BY.CLIENT, name: 'Client' },
  { value: ORDER_PLACED_BY.ME, name: 'Me' },
  { value: ORDER_PLACED_BY.OTHER_ASSOCIATE, name: 'Other Associates' },
];

export const ORDERS_FILTERS_BRAND = [
  { value: ORDER_BRAND.NM, name: 'Neiman Marcus' },
  { value: ORDER_BRAND.BG, name: 'Bergdorf Goodman' },
];

export const ORDERS_FILTERS_CHANNEL = [
  { value: ORDER_CHANNEL.inStore, name: 'In Store' },
  { value: ORDER_CHANNEL.online, name: 'Online' },
  { value: ORDER_CHANNEL.connect, name: 'Connect' },
];
export const ORDERS_FILTERS_STATUS = [
  { value: ORDER_STATUS.SHIPPED, name: 'Shipped' },
  { value: ORDER_STATUS.PENDING, name: 'Pending' },
  { value: ORDER_STATUS.ISSUE, name: 'Issues' },
  { value: ORDER_STATUS.RETURNED, name: 'Returned' },
  { value: ORDER_STATUS.TAKE, name: 'Take' },
  { value: ORDER_STATUS.CANCELLED, name: 'Cancelled' },
];

export const ORDER_SERVICES_DEPT_TYPE = {
  150: 'Alteration',
  903: 'Gift Wrap',
  995: 'Delivery fee',
  904: 'Service name',
};

export const DEFAULT_ASSOCIATE_FILTERS = {
  date: ORDERS_FILTER_BY_DATE[2].value,
  status: [],
  channel: [],
};

export const DEFAULT_CLIENT_FILTERS = {
  date: ORDERS_FILTER_BY_DATE[2].value,
  placedBy: Object.values(ORDER_PLACED_BY),
  channel: [],
  brand: [],
};
